<template>
  <div
    class="grid text-center"
    :class="[
      size === 'base' ? 'gap-2' : '',
      size === 'sm' ? 'gap-1' : ''
    ]"
    :style="{
      gridTemplateColumns: `repeat(${cols ?? 1}, minmax(0, 1fr))`
    }"
  >
    <div
      class="font-bold rounded-xl cursor-pointer border transition relative flex items-center"
      :class="[
        modelValue.includes(option.value) || (modelValue.length === 0 && isDefaultActive) ? 'bg-white border-light-100 dark:bg-dark-600 dark:text-dark-50 dark:border-dark-500 text-light-950' : 'bg-light-200 border-light-200 dark:border-dark-950 dark:bg-dark-950 dark:text-dark-500 text-light-700',
        size === 'base' ? 'text-lg p-6 justify-center' : 'justify-between',
        size === 'sm' ? 'text-base py-3 px-4' : ''
      ]"
      :style="{
        gridColumn: `span ${option.cols ?? 1} / span ${option.cols ?? 1}`
      }"
      @click="toggleValue(option.value)"
      v-for="option in options"
    >
      {{ option.label }}

      <IconBase
        name="cute/check-fill"
        :class="[
          size === 'base' ? 'absolute top-3 right-3' : '',
          modelValue.includes(option.value) || (modelValue.length === 0 && isDefaultActive) ? '' : 'opacity-50'
        ]"
        :width="14"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = withDefaults(defineProps<{
  modelValue: string[]
  options: {
    label: string
    value: string
    cols?: number
  }[]
  cols?: number
  isDefaultActive?: boolean
  size?: 'base' | 'sm'
}>(), {
  modelValue: () => [],
  options: () => [],
  cols: 2,
  isDefaultActive: false,
  size: 'base'
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: string[]): void
}>()

const toggleValue = (value: string) => {
  if (props.modelValue.includes(value)) {
    emit('update:modelValue', props.modelValue.filter(g => g !== value))
  } else {
    emit('update:modelValue', [ ...props.modelValue, value ])
  }
}
</script>